import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragHandle from '@components/common/DnD/DragHandle';
import ApiUsageBreakdownTable from './ApiUsageBreakdownTable';

interface SortableTableItemProps {
  dimension: string;
}

const SortableTableItem = ({ dimension }: SortableTableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: dimension,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: 'relative' as const,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <DragHandle {...attributes} {...listeners} />
      <ApiUsageBreakdownTable dimension={dimension} />
    </div>
  );
};

export default SortableTableItem;
